/* 
  教师注册
*/

import request from "@/utils/request";

//获取教师信息参数
export function getRegisterParam() {
  return request({
    url: window.config.baseUrl4WebTeacher + "/teacher/register/getParam",
    method: "get"
  });
}


//注册教师信息
export function registerTchInfo(data) {
  return request({
    url: window.config.baseUrl4WebTeacher + "/teacher/register/registerTchInfo",
    method: "post",
    data
  });
}

/** 注册页头像上传（无 token） */
export function registerUploadHeadUrl() {
  return window.config.baseUrl4WebTeacher + "/teacher/register/upLoadHeadImage";
}